var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ve-histogram',{attrs:{"data":_vm.chartdata,"extend":_vm.chartExtend,"judge-width":true,"settings":_vm.chartSettings,"grid":_vm.grid,"legend":_vm.legends,"height":"340px","colors":_vm.colors}})}
var staticRenderFns = []

export { render, staticRenderFns }